import { jsxs as _jsxs } from "react/jsx-runtime";
import * as S from "../../styles";
import { getRevision } from "../../utils/revision";
export var Revision = function() {
    var _getRevision = getRevision(), appName = _getRevision.appName, appRevision = _getRevision.appRevision;
    return /*#__PURE__*/ _jsxs(S.Box, {
        display: "none",
        id: "neru-revision",
        children: [
            appName,
            " ",
            appRevision
        ]
    });
};

//# sourceMappingURL=Revision.js.map